export const information = {
  entgeltumwandlungsZeitpunkt: 'false = ab 01.01.2022; - true = mit Inkrafttreten der VO',
  artVwlEntgeltumwandlung: '0 = Entgeltumwandlung - 1 = BAV-Umwandlung - 2 = AVWL;',
  lawyer: 'false = Kanzlei Stulle Wagner & Kollegen - true = Kanzlei Lederer & Partner;',
  behandlungTeilzeitkraefteVwl: 'false = Wie Vollzeitbeschäftigte - true = Anteilig im Verhältnis zur Arbeitszeit;',
  entgeltumwandlungseinheit: 'false = Prozent - true = Euro;',
  unverfallberkeitsregelung: 'false = Gesetzliche Unverfallbarkeit - true = Sofortige vertragliche Unverfallbarkeit',
  behandlungTeilzeitkraefteBav: 'false = Wie Vollzeitbeschäftigte - true = Anteilig im Verhältnis zur Arbeitszeit'
};
